import { emailSendApi, emailVerifyApi, newPasswordSetApi, smsEmailVerifyApi, smsSendApi, smsVerifyApi } from "./reset-password";
import { errorResponseHandler } from "./error-response-handler";
import {
	EmailModel,
	PasswordSetModel,
	PhoneNumberModel,
	PhoneVerificationModel,
	SmsEmailVerifyModel,
	TokenModel,
} from "../shared/models/Verification.model";
import { successResponseHandler } from "./success-response-handler";
import { ApiResponseModel } from "../shared/models/ApiResponse.model";
import { SuccessMessageEnum } from "../shared/enums/success-message.enum";
import { ErrorMessageEnumApi } from "../shared/enums/error-message.enum";

function emailVerify(
	token: TokenModel,
	setValue: any,
	setUsers: any,
	setError: any,
	setSectionNumber: any,
	setIsLoading: any,
	type: string
) {
	setIsLoading(true);
	emailVerifyApi(token)
		.then((res) => {
			const response: ApiResponseModel = res.data;
			if (response.result.code === "resetpwd-000") {
				successResponseHandler(setSectionNumber, type, setIsLoading, response.list);
			} else {
				errorResponseHandler(res.data, setError, setIsLoading, setSectionNumber);
			}
			//to decide whether to preset form with value if there is only one user ot set users to list for a manual pick
			res.data.list.length > 1 ? setUsers(res.data.list) : setValue("account", res.data.list[0]);
		})
		.catch((err) => {
			// route to email enter if token invalid
			setSectionNumber(1);
			setError("root.serverError", {
				type: "general",
				message: ErrorMessageEnumApi.SERVER_ERROR,
			});
			setIsLoading(false);
		});
}

function emailSend(email: EmailModel, setError: any, setSectionNumber: any, setIsLoading: any, type: string) {
	setIsLoading(true);
	emailSendApi(email)
		.then((res) => {
			const response: ApiResponseModel = res.data;
			if (response.result.code === "resetpwd-000") {
				successResponseHandler(setSectionNumber, type, setIsLoading, response.list);
			} else {
				errorResponseHandler(res.data, setError, setIsLoading, setSectionNumber, type);
			}
		})
		.catch((err) => {
			// route to email enter if token invalid
			setSectionNumber(1);
			setError("root.serverError", {
				type: "general",
				message: ErrorMessageEnumApi.SERVER_ERROR,
			});
			setIsLoading(false);
		});
}

function smsSend(
	phoneNumber: PhoneNumberModel,
	setError: any,
	setIsLoading: any,
	setSectionNumber: any,
	type: string,
	timesTriggered: number,
	setTimesTriggered: any,
	setIsDisabled: any,
	sentCallback: any
) {
	if (!phoneNumber) {
		return;
	}
	setIsLoading(true);
	smsSendApi(phoneNumber)
		.then((res) => {
			if (res.data.result.code === "resetpwd-000") {
				setTimesTriggered(timesTriggered + 1);
				setIsDisabled(true);
				sentCallback();
				setError("root.serverError", {
					type: "success",
					message: timesTriggered === 0 ? SuccessMessageEnum.SMS_SENT : SuccessMessageEnum.SMS_SENT_AGAIN,
				});
				successResponseHandler(setSectionNumber, type, setIsLoading);
			} else {
				errorResponseHandler(res.data, setError, setIsLoading, setSectionNumber, type);
			}
		})
		.catch((err) => {
			// route to email enter if token invalid
			setError("root.serverError", {
				type: "general",
				message: ErrorMessageEnumApi.SERVER_ERROR,
			});
			setIsLoading(false);
		});
}

function smsVerify(phoneVerificationData: PhoneVerificationModel, setError: any, setIsLoading: any, setSectionNumber: any, type: string) {
	if (!phoneVerificationData || !phoneVerificationData.apt_pin || !phoneVerificationData.phone_number) {
		return;
	}
	setIsLoading(true);
	smsVerifyApi(phoneVerificationData)
		.then((res) => {
			if (res.data.result.code === "resetpwd-000") {
				successResponseHandler(setSectionNumber, type, setIsLoading);
			} else {
				errorResponseHandler(res.data, setError, setIsLoading, setSectionNumber);
			}
		})
		.catch((err) => {
			setError("root.serverError", {
				type: "general",
				message: ErrorMessageEnumApi.SERVER_ERROR,
			});
			setIsLoading(false);
		});
}

function smsEmailVerify(
	verificationData: SmsEmailVerifyModel,
	setValue: any,
	setUsers: any,
	setError: any,
	setIsLoading: any,
	setSectionNumber: any,
	type: string
) {
	if (!verificationData || !verificationData.apt_pin || !verificationData.phone_number || !verificationData.email) {
		return;
	}
	setIsLoading(true);
	smsEmailVerifyApi(verificationData)
		.then((res) => {
			const response: ApiResponseModel = res.data;
			if (response.result.code === "resetpwd-000") {
				successResponseHandler(setSectionNumber, type, setIsLoading, response.list);
			} else {
				errorResponseHandler(res.data, setError, setIsLoading, setSectionNumber);
			}
			//to decide whether to preset form with value if there is only one user ot set users to list for a manual pick
			res.data.list.length > 1 ? setUsers(res.data.list) : setValue("account", res.data.list[0]);
		})
		.catch((err) => {
			setError("root.serverError", {
				type: "general",
				message: ErrorMessageEnumApi.SERVER_ERROR,
			});
			setIsLoading(false);
		});
}

function setPassword(passwordDTO: PasswordSetModel, setError: any, setIsLoading: any, setSectionNumber: any, type: string) {
	if (!passwordDTO || !passwordDTO.token || !passwordDTO.username || !passwordDTO.type || !passwordDTO.password) {
		return;
	}
	setIsLoading(true);
	newPasswordSetApi(passwordDTO)
		.then((res) => {
			if (res.data.result.code === "resetpwd-000") {
				successResponseHandler(setSectionNumber, type, setIsLoading);
			} else {
				errorResponseHandler(res.data, setError, setIsLoading, setSectionNumber);
			}
		})
		.catch((err) => {
			setError("root.serverError", {
				type: "general",
				message: ErrorMessageEnumApi.SERVER_ERROR,
			});
			setIsLoading(false);
		});
}

export { emailVerify, emailSend, smsSend, smsVerify, smsEmailVerify, setPassword };
